import { render, staticRenderFns } from "./DataUploadTable.vue?vue&type=template&id=0c0f4ea4&"
import script from "./DataUploadTable.vue?vue&type=script&lang=js&"
export * from "./DataUploadTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports